const MIXIN_MODEL_FORM_DATA = {
  model: {
    prop: 'formData',
    event: 'changeFormData'
  },

  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    modelFormData: {
      get () {
        return this.formData
      },

      set (val) {
        this.$emit('changeFormData', val)
      }
    }
  }
}

export {
  MIXIN_MODEL_FORM_DATA
}
